<template>
  <div class="pool-box">
    <div class="box-header">
      <span class="pool-name body-medium">{{ name }}</span>
      <div class="controls" v-if="pool_id > 0">
        <b-spinner small v-if="isDeleting" />
        <span v-else>
          <edit-icon @click="handleSetPoolToEdit" />
          <delete-icon @click="handleDeletePool" />
        </span>
      </div>
    </div>
    <p class="pool-description">{{ description }}</p>
    <div class="tickers">
      <span
        class="ticker"
        v-for="ticker in shownTickers"
        v-bind:key="ticker.ticker"
        v-b-tooltip.hover
        :title="ticker.ticker"
      >
        <img :src="ticker.icon" v-if="ticker.icon" />
        <gradient-icon v-else :ticker="ticker.ticker" small />
      </span>
    </div>
    <b-collapse v-model="isCollapseOpen">
      <div class="tickers">
        <span
          class="ticker"
          v-for="ticker in otherTickers"
          v-bind:key="ticker.ticker"
          v-b-tooltip.hover
          :title="ticker.ticker"
        >
          <img :src="ticker.icon" v-if="ticker.icon" />
          <gradient-icon v-else :ticker="ticker.ticker" small />
        </span>
      </div>
    </b-collapse>
    <div class="open-collapse-holder" v-if="otherTickers.length">
      <open-icon @click="toggleCollapse" v-if="!isCollapseOpen" />
      <close-icon @click="toggleCollapse" v-else />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import CloseIcon from "vue-material-design-icons/ChevronDoubleUp.vue";
import DeleteIcon from "vue-material-design-icons/Delete.vue";
import EditIcon from "vue-material-design-icons/Pencil.vue";
import GradientIcon from "./GradientIcon.vue";
import MainAlert from "./alerts/MainAlert.vue";
import OpenIcon from "vue-material-design-icons/ChevronDoubleDown.vue";
export default {
  components: { GradientIcon, OpenIcon, CloseIcon, EditIcon, DeleteIcon },
  name: "pool-box",
  props: {
    name: String,
    pool_id: Number,
    tickers: Array,
    description: String,
  },
  data() {
    return {
      isCollapseOpen: false,
      isDeleting: false,
    };
  },
  computed: {
    shownTickers() {
      if (this.tickers) {
        return this.tickers.slice(0, 28);
      } else {
        return [];
      }
    },
    otherTickers() {
      if (this.tickers) {
        return this.tickers.slice(28);
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions("portfolioManagerStore", ["deletePool"]),
    ...mapMutations("portfolioManagerStore", ["setPoolToEdit"]),
    toggleCollapse() {
      this.isCollapseOpen = !this.isCollapseOpen;
    },
    handleDeletePool() {
      this.isDeleting = true;
      this.deletePool(this.pool_id)
        .then(() => {
          this.$toast.success({
            component: MainAlert,
            props: {
              message: this.$t("portfolioManager.createPoolModal.poolDeleted"),
            },
          });
        })
        .catch(() =>
          this.$toast.error({
            component: MainAlert,
            props: {
              message: this.$t("errors.actionFailed"),
            },
          })
        )
        .finally(() => (this.isDeleting = false));
    },
    handleSetPoolToEdit() {
      this.setPoolToEdit(this.pool_id);
      this.$bvModal.hide("pools-modal");
      this.$bvModal.show("create-pool-modal");
    },
  },
};
</script>

<style lang="scss" scoped>
.pool-box {
  @include dps-box;
  margin-bottom: toRem(15);
  padding: toRem(10);
  .open-collapse-holder {
    width: 100%;
    display: flex;
    justify-content: center;
    color: $primaryColor;
    .material-design-icon {
      cursor: pointer;
    }
  }
  .pool-name {
    font-size: $s-font;
  }
  .pool-description {
    font-size: toRem(13);
    color: $subtleText;
  }
  .tickers {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .ticker {
      margin-right: toRem(7);
      margin-bottom: toRem(7);
      img,
      .gradient-icon {
        width: toRem(18);
        height: toRem(18);
        border-radius: 50px;
        display: inline-flex;
        margin-right: 0;
      }
    }
  }
  .box-header {
    display: flex;
    justify-content: space-between;

    .material-design-icon {
      cursor: pointer;
      color: $primaryColor;
    }
    .material-design-icon + .material-design-icon {
      margin-left: toRem(13);
    }
  }
}
</style>